import { without } from 'lodash';
import { schema as objectiveRequirementsAndObjectivesPurposeTypeSchema } from './ObjectiveRequirementsAndObjectivesPurposeType.schema';
import { schema as objectiveRequirementsAndObjectivesPurposeDetailsSchema } from './ObjectiveRequirementsAndObjectivesPurposeDetails.schema';
import { schema as objectiveRequirementsAndObjectivesRefinanceAndDebtConsolidationSchema } from './ObjectiveRequirementsAndObjectivesRefinanceAndDebtConsolidation.schema';
import { YesNoOption, yesNoOptions } from '../global/YesNoOption.enum';
import { labeled, enumRequired } from '../../util/joi';

export const schema = (Joi: any, label: string) => {
  const availableYesNoOptions = without(
    yesNoOptions,
    YesNoOption.none.name,
    YesNoOption.yes_discharged.name,
    YesNoOption.not_important.name
  );
  return Joi.object({
    purposeType: objectiveRequirementsAndObjectivesPurposeTypeSchema(Joi, label),
    purposeDetails: objectiveRequirementsAndObjectivesPurposeDetailsSchema(Joi, label),
    refinanceAndDebtConsolidation: objectiveRequirementsAndObjectivesRefinanceAndDebtConsolidationSchema(
      Joi,
      label
    )
  }).when('.purposeDetails.debtConsolidation', {
    is: Joi.boolean().valid(true),
    then: Joi.object().keys({
      creditCardReducedOrCancelled: enumRequired(
        Joi,
        availableYesNoOptions,
        labeled(label, 'Will existing credit card limits be reduced or cancelled?')
      ),
      creditCardReducedOrCancelledComments: Joi.alternatives().conditional(
        'creditCardReducedOrCancelled.name',
        {
          is: YesNoOption.yes.name,
          then: Joi.string()
            .required()
            .label(
              labeled(
                label,
                'Will existing credit card limits be reduced or cancelled - Comments'
              )
            ),
          otherwise: Joi.any()
        }
      )
    })
  });
};

export default {
  schema
};
